
import React, { useEffect, useState } from "react";
import { Menu, Button, MenuProps, Input, Modal, Tabs, Select, message, notification, Row, Col, Form} from 'antd';

const CreateProfileModal = ({ displayCreateProfile, setDisplayCreateProfile, createProfile }) => {

    const [form] = Form.useForm();
    const onFinish = (values) => {
        const newProfile = values;
        createProfile(newProfile)
        setDisplayCreateProfile(false);
        form.resetFields();
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    return (
        <Modal title="Create Profile" visible={displayCreateProfile} footer={null} onCancel={() => { setDisplayCreateProfile(false); }}>
            <div style={{ display: "flex", flexDirection: "row", gap: 15, justifyContent: "center", }}>
                <Form
                    form={form}
                    labelCol={{
                        span: 8,
                    }}
                    wrapperCol={{
                        span: 16,
                    }}
                    initialValues={{
                        remember: true,
                    }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                >
                    <Form.Item
                        label="Profile Name"
                        name="name"
                        rules={[
                            {
                                required: true,
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="Exchange Id"
                        name="exchange"
                        rules={[
                            {
                                required: true,
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="Api Key"
                        name="api_key"
                        rules={[
                            {
                                required: true,
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="Api Secret"
                        name="api_secret"
                        rules={[
                            {
                                required: true,
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>


                    <Form.Item
                        wrapperCol={{
                            offset: 18,
                            span: 18,
                        }}
                    >
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </Modal>
    );
};

export default CreateProfileModal;